module.exports = __webpack_public_path__ + "img/huolongguo.410b07da.jpg";